/**
 * @module /google-recaptcha/loadRecaptchaScript
 * @description
 * Вспомогательный модуль для подгрузки капчи
 */

export default (callbackName, locale, reCaptchaCallback) => {
  loader(`https://www.google.com/recaptcha/api.js?onload=${callbackName}&hl=${locale}&render=explicit`, reCaptchaCallback);

  function loader(src, reCaptchaCallback) {
    let testDouble = document.querySelector(`script[src='${src}']`);

    // Проверяем есть ли капча с бэкенда, если есть, то не дублируем её в коммоне, а просто вызываем reCaptchaCallback
    let testBackend = document.querySelector('[src^="https://www.google.com/recaptcha/api.js"]')

    if (!testDouble && !testBackend) {
      const script = document.createElement('script');
      script.setAttribute('src', src);
      script.setAttribute('async', '');
      script.setAttribute('defer', '');
      document.body.insertAdjacentElement('afterend', script);
    } else {
      reCaptchaCallback();
    }
  }
}
